export enum GithubAccountStatus {
  CONNECTED = 'connected',
  PENDING = 'pending',
}
